export default {"src":"/_next/static/media/pos.bc608e80.svg","height":1470,"width":800,"blurWidth":0,"blurHeight":0};